module.exports = "../images/icons/download.svg";